import { useDispatch, useSelector } from "react-redux";

import { filterByFeatured } from "../features/filter/filterSlice";

const Filter = () => {
  const dispatch = useDispatch();

  const { status } = useSelector((state) => state.filter);

  const handleClick = (value) => {
    dispatch(filterByFeatured(value));
  };

  return (
    <div className="flex items-center space-x-4">
      <button
        onClick={() => handleClick("all")}
        className={`lws-filter-btn ${status === "all" && "active-filter"}`}
      >
        All
      </button>
      <button
        onClick={() => handleClick("featured")}
        className={`lws-filter-btn ${status === "featured" && "active-filter"}`}
      >
        Featured
      </button>
    </div>
  );
};

export default Filter;
